export const BCorpLogo = () => (
  <img src="/next-assets/images/logos/BCorp_Filled.svg" alt="Athena Logo" width="90px" height="133px" loading="lazy" />
);
